import ReactHtmlParser from "react-html-parser"

// Pre-load all translation JSONs. import.meta.glob replaces dynamic require()
// because Vite/esbuild does not support require() in the browser.
const _translations = import.meta.glob('../translations/**/*.json', {
  eager: true,
  import: 'default',
})

// Pre-load all images from app/images for loadImage()
const _images = import.meta.glob('../images/**/*', {
  eager: true,
  query: '?url',
  import: 'default',
})

function _getTranslation(langKey, section) {
  const key = `../translations/${langKey}/${section}.json`
  return _translations[key] ?? {}
}

export function loadTexts(section) {
  const lang = localStorage.getItem("language") || "es"
  return _getTranslation(lang, section)
}

export function loadTextsLocalStorage(section) {
  const lang = localStorage.getItem("LOGIN_LANGUAGE") || "es"
  return _getTranslation(lang, section)
}

export function sanitize(text) {
  return ReactHtmlParser(text)
}

export function setLanguage(lang) {
  localStorage.setItem("language", lang)
}

export function getLanguage() {
  return localStorage.getItem("language") || "es"
}

export function loadImage(image) {
  const key = `../images/${image}`
  return _images[key] ?? key
}
